import { MapPlacePredictionsService } from './../../../../ubi-map/src/lib/services/map-place-predictions.service';
import { AdvancedMapPlacePredictionsService } from 'libs/advanced-map/src/lib/services/advanced-map-place-predictions.service';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, AfterViewInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { CoordinateSearchFacade } from '../coordinates/coordinate-search-facade.service';
import { CoordinateDropdownRow } from '../coordinates/models/coordinate-search.model';
import { buildCoordinateLocationPayload } from '../coordinates/coordinate-location-payload.util';
import {
  extractLocationSearchValue,
  isCoordinateLocationSearchValue,
} from '../coordinates/coordinate-location-search.util';
import { CoordinateMapControllerService } from '../coordinates/coordinate-map-controller.service';
import { CoordinateMapContextService } from '../coordinates/coordinate-map-context.service';
import { CoordinateMapContext } from '../coordinates/models/coordinate-map-context.model';
import { supportsLocationAddressSearch } from '../coordinates/coordinate-search-capability.util';
import { Subject, Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { NodeService } from 'apps/ubivu-panel/src/app/serveices/node.service';
import { TopBarService } from 'libs/top-bar/src/lib/top-bar.service';
import { cloneDeep, find, includes, isEmpty, remove } from '@ubi-cell/core-utils';
import { LightHelper } from '../Helper/light.helper';
import { CommonTopBar } from '../Helper/common-top-bar';
import { TranslateService } from '@ngx-translate/core';
import { WifiHelper } from '../Helper/wifi.helper';
import { TooltipPosition } from '@angular/material/tooltip';
import { StorageService } from 'libs/base/src/lib/services/storage.service';
import { UbviCalendarRangeModel } from 'libs/ubivu-date-range-popup/src/lib/model/ubivu-calendar-range.model';
import {
  DateTimeCore,
  DateTimeFormats,
} from '@ubi-cell/date-time';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'libs/api/src/lib/services/shared.service';
import UsersPreferencesUtils from 'libs/base/src/lib/utils/users-preferences.utils';
import { preferencesConstant } from 'apps/ubivu-panel/src/app/constants';
import { GlobalToastService } from 'libs/global-toast/src/lib/services/global-toast.service';

@Component({
    selector: 'ubi-cell-top-bar-filter',
    templateUrl: './top-bar-filter.component.html',
    styleUrls: ['./top-bar-filter.component.scss'],
    standalone: false
})
export class TopBarFilterComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() mainScreen: string = '';
  @Input() subScreen: string = '';
  @Input() workOrderCapabilityType: string = '';

  hardwareVersions: Array<any> = [];
  transformerCableKits: Array<any> = [];
  txHardwareVersions: Array<any> = [];
  venues: Array<any> = [];
  currentConfiguration: any;
  gisAssetsColumns: Array<any> = [];
  listOfActiveAlertThreshold: Array<any> = [];
  listOfEmptyFields: any = [];
  customFields: Array<any> = [];
  expandFilterBlock: boolean = false;
  expandSearchBlock: boolean = false;
  expandMenuFilter: boolean = false;
  searchText: string = '';
  topBarFilters: Array<any> = [];
  filterChange = true;
  positionOptions: TooltipPosition = 'below';
  totalNodesCount: number = 0;
  preferenceCall: boolean = true;
  transformer_load: Array<any> = [];

  currentFilterSub$: Subscription;
  tagListChangeDetect$: Subscription;
  currentUserDetailsSub$: Subscription;
  thresholdSub$: Subscription;
  emptyFieldSub$: Subscription;
  hardwareSub$: Subscription;
  txHardwareVersionsSub$: Subscription;
  gisAssetsSub$: Subscription;
  venueListSub$: Subscription;
  tagListSub$: Subscription;
  customFiledSub$: Subscription;
  tiltStatusValue: Subscription;
  pqStatusValue: Subscription;
  nodeSelectionSub$: Subscription;
  tagSelectionSub$: Subscription;
  nodeStatusSub$: Subscription;
  txTypeStatusSub$: Subscription;
  activeAlertSub$: Subscription;
  alertEventSub$: Subscription;
  customerTimeZoneSub$: Subscription;
  totalNodeCount$: Subscription;
  filterTagParamsSub$: Subscription;
  notificationFilterSub$: Subscription;
  selectedNotificationFilterSub$: Subscription;
  updateThresholdConfiguration$: Subscription;
  deleteNotificationFilter$: Subscription;

  placePredictions: any[] = [];
  coordinateSearchRow: CoordinateDropdownRow | null = null;
  private searchInput$ = new Subject<string>();
  private coordinateSearchSub?: Subscription;
  private coordinateLocationSearchSub?: Subscription;
  notificationsHWVersionSub$: Subscription;
  formerCableKitsSub$: Subscription;
  notificationAlertListSub$: Subscription;
  notificationAlertsList:Array<any> = [];
  calendarRangeModel: UbviCalendarRangeModel;
  formDateChanged: boolean = false;
  showInterval : boolean = true;
  prevStartDate= null;
  prevEndDate= null;
  firstTime = true;
  isValid : boolean = false;
  searchIsVisible = false;
  @ViewChild('filterHeight') filterHeight!: ElementRef;
  savedFilterAppliedForNotificationsSub$: Subscription;
  getFilterOnRefreshForNotificationSub$: Subscription;
  viewNodeFilterSub$: Subscription;
  validPowerQualityScreens = ['power_quality_sustained', 'power_quality_momentary', 'power_quality_voltage'];
  dynamicSearchBarSub$: Subscription;
  dynamicSearchByFields: string = '';
  currentModeSelectionSub: Subscription;
  isPowerQualityTemporalViewEnable: boolean = false;
  positionOptionsForDateRange: TooltipPosition = 'above';  
  savedFilterAppliedForPowerQualitySub$: Subscription;
  getFilterOnRefreshForPowerQualitySub$: Subscription;
  savedFilterAppliedForWorkOrderSub$: Subscription;
  notificationExceptionsList:Array<any> = [];
  notificationExceptionsListSub$: Subscription;
  digitalInspectionPrefSub$: Subscription;
  digitalInspectionPeriodSub$: Subscription;

  //features objects variables
  constructor(protected _nodeService: NodeService,
    public _topBarConf: TopBarService,
    public lightHelperObj: LightHelper,
    public ctb: CommonTopBar,
    private translateService: TranslateService,
    public wifiHelperObj: WifiHelper,
    public _mapPlacePredictionsService: MapPlacePredictionsService,
    private _advancedMapPlacePredictionsService: AdvancedMapPlacePredictionsService,
    public _storageService: StorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private eRef: ElementRef,
    private _sharedService: SharedService,
    private _coordinateSearchFacade: CoordinateSearchFacade,
    private _coordinateMapController: CoordinateMapControllerService,
    private _coordinateMapContext: CoordinateMapContextService,
    private cdr: ChangeDetectorRef,
    private _globalToastService: GlobalToastService
  ) {
  }

  /** Coordinate search only on screens that support location address search. */
  get isCoordinateSearchActive(): boolean {
    return supportsLocationAddressSearch(
      this.mainScreen,
      !!this._topBarConf?.currTopBarConfig?.value?.search_only
    );
  }

  ngAfterViewInit(): void {

  }

  /** Resolves the active page map context (registered or legacy ubi-map fallback). */
  getCoordinateMapContext(): CoordinateMapContext {
    return this._coordinateMapContext.resolve(
      this._mapPlacePredictionsService,
      this._advancedMapPlacePredictionsService
    );
  }

  ngOnInit(): void {
    if (this.isCoordinateSearchActive) {
      this.coordinateSearchSub = this._coordinateSearchFacade
        .coordinateRow$(this.searchInput$.asObservable())
        .subscribe((row) => {
          this.coordinateSearchRow = row;
          this.cdr.markForCheck();
        });
      this.subscribeCoordinateLocationSearch();
    }
    if(this.mainScreen === preferencesConstant.WORK_ORDER){
      this.ctb.setWorkOrderCapabilityType(this.workOrderCapabilityType);
    }

    this.getCustomerTimeZone(); // get customer time zone
    
    this.ctb.setMainScreenType(this.mainScreen);
    this.searchPlaceHolder();
    this.subscribeDynamicSearchByFields();
    this.updateHeight();
    
    if (this.currentFilterSub$) {
      this.currentFilterSub$.unsubscribe();
    }
    this.currentFilterSub$ = this._topBarConf.currentFilterConfiguration.subscribe(value => {
      if (!isEmpty(value)) {
        this.preferenceCall = true;
        // this.crs = [];
        this.ctb.setCapabilityType(this.mainScreen);
        this.ctb.setSubScreen(this.subScreen);
        this.ctb.attributesData = cloneDeep(value) || [];
        this.ctb.attributes = value.attributes ? cloneDeep(value.attributes) : [];

        
        this.getAlertTypeBasedOnConfiguration(this.mainScreen);
        this.getExceptionTypeBasedOnConfiguration(this.mainScreen)
        this.notificationFilter();
        this.viewNodeFilter();
        this.selectedNotificationFilter(); // empty filter when select node from notification
        this.getFilterTagParams(); // get filter tags chip while click on tag from admin configuration
        // get notification filter from view on map button click
        if (!['aqi','notifications', 'wifi' ].includes(this.mainScreen)) {
          this.getCustomFields(this.mainScreen); // get Custom Fields
        }
        if (this.mainScreen == 'tilt_monitoring') {
          this.getTiltStatusFields(); // get Tilt Status Fields
        }
        if (this.mainScreen.includes('power_quality')) {
          this.getPQStatusFields(); // get Tilt Status Fields
          this.changeCurrentViewMode();
        }
        this.subscribeTagCreationFilter(); // create filter chip for tag creation

        this.deleteNotificationFilter(); // remove notification filter

        if (this.mainScreen === 'light') {

          this.getCurrentUserDetails();// get current user details

          this.getThresholdBasedOnConfiguration(); // get threshold based on configuration

          //this.getEmptyFieldThreshold(); // get Empty Field thresholds

          this.getHardwareVersionsLists();  // get hardware versions

          this.getGISAssetsColumnList(); // get gis assets columns list

          this.updateThresholdConfiguration(); // update threshold configuration

          this.getExternalStreetLIghtFilterData(); // get external street light filter data
        } else if (this.mainScreen === 'wifi') {
          this.getVenueLists(); // get wifi venue lists
        } else if (this.mainScreen === 'aqi') {
          this.getThresholdBasedOnConfiguration(); // get threshold based on configuration
          this.updateThresholdConfiguration();
        } else if(this.mainScreen === 'transformers'){
          this.getThresholdBasedOnConfiguration();
          this.updateThresholdConfiguration(); // get threshold based on configuration
          this.getTransformersHWVersionList();  // get hardware versions
          this.getCableKitListForNotifications(this.mainScreen);
        } else if(this.mainScreen === 'cameras_video'){
          this.updateThresholdConfiguration();
          this.getThresholdBasedOnConfiguration(); // get threshold based on configuration;
        } else if(this.mainScreen === 'notifications'){
          this.ctb.productTypes = this._storageService.getStorageItem('availableProductType') || [];
          this.ctb.selectedProductType = this.ctb.productTypes[0].key;
          this.ctb.initializeMinMaxRangOfCal();
          this.changeAttributeValueBasedOnProductType();
        } else if(this.isPowerQualityScreen()) {
          this.ctb.initializeMinMaxRangOfCal();
          this.getTransformersHWVersionList();  // get hardware versions
        } else if(this.mainScreen === preferencesConstant.WORK_ORDER){
          this.ctb.initializeMinMaxRangOfCal();
          this.ctb.selectedDateRange = null;
          this.ctb.isCalenderVisible = true;
        }

        this.getTagLists();  // get Tag Lists

        if(!this._topBarConf?.currTopBarConfig?.value?.search_only ) {
          if(this.mainScreen !== 'planning'){
            this.getUserFilter(); // get user filter
            this.ctb.getRecentSearch(this.mainScreen); //get list of recent searches by users
          }
        }

        this.getSuggestedFilters(); // get suggested filters

        this.getPreferences(); // get preference from local storage

        if (!this.isCoordinateSearchActive) {
          this.coordinateSearchRow = null;
        }

        this.addTagFilter(); // create filter chip for tag

        this.subscribeNodeStatusFilter(); // create filter chip for status while click on node status
        this.subscribeTxTypeFilter(); // create filter chip for status while click on node status
        // this.notificationFilter();

        this.subscribeActiveAlerts(); // create filter chip for active alerts

        this.subscribeExceptionEvents(); // create filter chip for active events (Digital Inspection)
        this.subscribeDigitalInspectionPeriodFilter(); // create filter chip for digital inspection period
        this.subscribeDashBoardInsightFilter(); // create filter chip for notiviation (dashboad Insights)
        if (this.ctb.selectedDateRange)
          (window as any).dataLayer.push({
            dateRange: this.ctb.selectedDateRange
          })
      }
    });

    this.subscribeNotificationsSavedFilter(); // Create a filter chip when a filter is applied from the saved filter list
    this.subscribeNotificationGetFilterOnRefresh(); // create filter chip while auto refresh notification page

    this.subscribePowerQualitySavedFilter(); // Create a filter chip when a filter is applied from the saved filter list
    this.subscribePowerQualityGetFilterOnRefresh(); // create filter chip while auto refresh power quality page

    this.subscribeWorkOrderSavedFilter(); // Create a filter chip when a filter is applied from the saved filter list
    this.getTotalNodeCount();// display total node count
  }

  updateHeight() {
    const height = this.filterHeight?.nativeElement?.offsetHeight;
    this._topBarConf.updateHeight(height);
  }

  changeAttribute(event, attributeType) {
    this.ctb.onChangeAttribute(event, attributeType);
    const dropdownSelectedText = this.translateService.instant(this.ctb?.attributes.find(attribute => attribute?.value == event?.value)?.name || '');
    (window as any).dataLayer.push({
      event: 'filter_attribute_selection',
      dropdown_value: dropdownSelectedText
    });
  }

  searchPlaceHolder(){
    if (this.mainScreen == 'aqi') {
      this.ctb.searchPlaceHolder = this.expandFilterBlock ? 'search_place_holder' : 'search_place_holder_with_location';
    }
    if(this.mainScreen == 'notifications'){
        this.ctb.searchPlaceHolder = this.expandFilterBlock ? 'transformer_search_place_holder' : 'transformer_search_place_holder_with_location';
    }
    if(this.mainScreen == 'wifi'){
        this.ctb.searchPlaceHolder = this.expandFilterBlock ? 'search_place_holder_traffic' : 'search_place_holder_traffic_with_location';
    }
    if( this.mainScreen == 'cameras_video'){
      this.ctb.searchPlaceHolder = this.expandFilterBlock ? 'search_place_holder_traffic' : 'search_place_holder_cameras_video_with_location';
    }
    if(this.mainScreen == 'tilt_monitoring'){
      this.ctb.searchPlaceHolder = this.expandFilterBlock ? 'tilt_search_place_holder' : 'tilt_search_place_holder_with_location';
    }
    if (this.mainScreen == preferencesConstant.WORK_ORDER) {
      this.ctb.searchPlaceHolder = 'work_order_search_place_holder';
    }
    if (this.mainScreen == 'planning') {
      this.ctb.searchPlaceHolder = 'planning_search_place_holder';
    }

    if (this.ctb?.isDynamicFieldEnabled) {
      this.ctb.searchPlaceHolder = this.dynamicSearchPlaceHolder();
    }
  }

  /**
   * The searchable columns are published by the table once its presets are loaded. On Power
   * Quality the retained value is dropped because it belongs to the screen the user came from
   * and would otherwise be kept for the whole visit by the rule below.
   */
  subscribeDynamicSearchByFields() {
    const isPowerQualityScreen = this.validPowerQualityScreens.includes(this.mainScreen);

    this.dynamicSearchBarSub$?.unsubscribe();
    this.dynamicSearchBarSub$ = this._topBarConf.dynamicSearchBarValue
      .pipe(skip(isPowerQualityScreen ? 1 : 0))
      .subscribe(value => {
        // Power Quality only exposes searchable columns on the transformers tab; the feeder and
        // substation tabs publish nothing, so the resolved columns are kept for the whole visit.
        const keepResolvedFields = isEmpty(value) && this.validPowerQualityScreens.includes(this.mainScreen);
        if (!keepResolvedFields) {
          this.dynamicSearchByFields = value ?? '';
        }
        this.searchPlaceHolder();
      });
  }

  /**
   * On Power Quality the transformer defaults stand in until the transformers tab has been
   * opened, otherwise the user is left with a bare "Search" on the feeder / substation tabs.
   */
  dynamicSearchPlaceHolder(): string {
    if (!isEmpty(this.dynamicSearchByFields)) {
      const searchBy = this.translateService.instant('search_by');
      const address = this.translateService.instant('address');

      return this.expandFilterBlock
        ? `${searchBy} ${this.dynamicSearchByFields}`
        : `${searchBy} ${this.dynamicSearchByFields}, ${address}`;
    }

    if (this.validPowerQualityScreens.includes(this.mainScreen)) {
      return 'power_quality_search_place_holder';
    }

    return this.translateService.instant('search');
  }

  setAttribute(value) {
    this.ctb.attributes = value;
  }

  // get Hardware Version Lists
  getHardwareVersionsLists() {
    this.hardwareVersions = [
      { "name": "a1", "value": "A1", "selectable": true },
      { "name": "w1", "value": "W1", "selectable": true }
    ];
    if (this.hardwareSub$) {
      this.hardwareSub$.unsubscribe();
    }
    if (this.mainScreen == 'light') {
      this.hardwareSub$ = this.ctb.getHardwareVersions().subscribe((response) => {
        const responseData = response['code'] == '200' && response?.data?.version ? response?.data?.version : [];
        responseData?.forEach(element => {
          const hardwareVersion = {
            name: element,
            value: element,
            selectable: true
          };
          this.hardwareVersions.push(hardwareVersion);
        });

        this.hardwareVersions.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );

        const hardwareVersionAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'bState');
        if (hardwareVersionAttribute) {
          this.ctb.attributesData.values['bState'] = this.hardwareVersions;
        }
      });
    }
  }

  // get Transformers Hardware Version Lists
  getTransformersHWVersionList() {
    if (this.txHardwareVersionsSub$) {
      this.txHardwareVersionsSub$.unsubscribe();
    }
    this.txHardwareVersions = [];
    if ((this.mainScreen == 'transformers') || this.isPowerQualityScreen()) {
      this.txHardwareVersionsSub$ = this.ctb.getTransformersHWVersions().subscribe((response) => {
        const responseData = response['code'] == '200' && response?.data?.version ? response?.data?.version : [];
        responseData?.sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1);
        responseData?.forEach(element => {
          const txHardwareVersions = {
            name: element,
            value: element,
            selectable: true
          };
          this.txHardwareVersions.push(txHardwareVersions);
        });
      });
    }

    let txHardwareVersionAttribute = this.ctb.attributesData?.attributes?.find((element) => element.value == 'hardwareVersion');
    this.txHardwareVersions = this.txHardwareVersions.sort((a, b) => (a.name > b.name ? 1 : -1));
    if (txHardwareVersionAttribute) {
      this.ctb.attributesData.values['hardwareVersion'] = this.txHardwareVersions;
    }
  }

  // get Tag Lists
  getTagLists() {
      this.tagListChangeDetect$ = this._topBarConf?.tagFilterUpdate.subscribe(value =>{
        if(value == true) {
          this.setTagListValue();
        }
      });
  }

  setTagListValue(){
    let tags = [];
    const responseData = this._topBarConf?.tagListResponse?.['code'] == '200' && this._topBarConf?.tagListResponse?.['data'] ? this._topBarConf?.tagListResponse?.['data'] : [];
    if(!isEmpty(responseData)) {
      responseData.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
      responseData.forEach(element => {
        const tag = {
          name: element.name,
          value: element.id,
          selectable: true
        };
        tags.push(tag);
      });
      let tagAttribute = this.ctb.attributesData?.attributes?.find((element) => element.value == 'tag');
      if (tagAttribute) {
        this.ctb.attributesData.values['tag'] = tags;
      }
    }
  }

  // get Custom Fields
  getCustomFields(type?) {
    this.ctb.beginCustomFieldsLoad();
    const customFields$ = this.ctb.getCustomFields(type);
    if (!customFields$) {
      this.ctb.markCustomFieldsUnavailable();
      return;
    }
    this.customFiledSub$ = customFields$.subscribe(response => {
      this.customFields = [];
      const responseData = response['code'] == '200' && response?.data ? response?.data : [];
      if (responseData && responseData.length > 0) {
        responseData.forEach(element => {
          if (element?.active) {
            const customFieldsColumns = {
              name: element.name,
              value: element.custom_name,
              type: element.type,
              selectable: true,
              values: Array.isArray(element.values) ? element.values : [],
            };
            this.customFields.push(customFieldsColumns);
          }
        });
        let customFieldsAttribute = this.ctb.attributesData?.attributes?.find((element) => element.value == 'custom_field');
        if (customFieldsAttribute) {
          this.ctb.attributesData.values['custom_field'] = this.customFields;
        }
      } else {
        this.ctb.attributes = this.ctb.attributes ? cloneDeep(this.ctb.attributes) : [];
        this.ctb.attributes = remove(this.ctb.attributes, function (n) {
          return n.value != 'custom_field';
        });
        this.ctb.attributesData.attributes = this.ctb.attributes;
        this.setAttribute(this.ctb.attributes);
      }
      this.ctb.setCustomFieldsAttribute(this.customFields);
      const pruneResult = this.ctb.pruneInactiveCustomFieldFilters(this.ctb.filters);
      if (pruneResult.pruned) {
        this.ctb.filters = pruneResult.filters;
        this.notifyInactiveCustomFieldFiltersPruned();
        // Emit and persist: capability requests already sent with the stale term must be reissued.
        this.ctb.onFilterChange(true, true);
      } else {
        this.ctb.onFilterChange(false, true, false);
      }
      this._topBarConf.publishCustomFieldsList(type, this.customFields);
    }, () => {
      this.ctb.markCustomFieldsUnavailable();
    });
  }

  getTiltStatusFields() {
    this.tiltStatusValue = this._topBarConf.getTiltStatusValue$.subscribe(tiltStatus => {
      let tiltStatusFields = [];
      if (tiltStatus && tiltStatus.length) {
        tiltStatus?.forEach(element => {
            const tiltStatusFieldsColumns = {
              name: element.label,
              value: element.key,
              selectable: true
            };
            tiltStatusFields.push(tiltStatusFieldsColumns);
        });
        
        if (this.ctb.attributesData?.attributes?.find((element) => element.value == 'tilt_status')) {
          this.ctb.attributesData.values['tilt_status'] = tiltStatusFields;
        }
      } 
      this.ctb.onFilterChange(false, true, false);
    });
  }

  getPQStatusFields() {
    this.pqStatusValue = this._topBarConf.getPQStatusValue$.subscribe(pqStatus => {
      let pqStatusFields = [];
      if (pqStatus && pqStatus.length) {
        pqStatus?.forEach(element => {
            const pqStatusFieldsColumns = {
              name: element.label,
              value: element.key,
              selectable: true
            };
            pqStatusFields.push(pqStatusFieldsColumns);
        });
        
        if (this.ctb.attributesData?.attributes?.find((element) => element.value == 'pq_status')) {
          this.ctb.attributesData.values['pq_status'] = pqStatusFields;
        }
      } 

      this.ctb.onFilterChange(false, true, false);
    });
  }


  // get gis assets column list
  getGISAssetsColumnList() {
    this.gisAssetsColumns = [];
    this.ctb.setGISAttribute(this.gisAssetsColumns);
    this.gisAssetsSub$ = this.lightHelperObj.getGISAssetsColumnList().subscribe((response) => {
      const responseData = response['code'] == '200' && response?.data ? response?.data : [];
      if (responseData && responseData.length > 0) {
        responseData.forEach(element => {
          const gisAssetsColumns = {
            name: element.name,
            value: element.custom_name,
            selectable: true
          };
          this.gisAssetsColumns.push(gisAssetsColumns);
        });

        let gisAssetsAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'gis_asset');
        if (gisAssetsAttribute) {
          this.ctb.attributesData.values['gis_asset'] = this.gisAssetsColumns;
        }
        this.ctb.setGISAttribute(this.gisAssetsColumns);
      } else {
        this.ctb.attributes = this.ctb.attributesData?.attributes ? cloneDeep(this.ctb.attributesData?.attributes) : [];
        this.ctb.attributes = remove(this.ctb.attributes, function (n) {
          return n.value != 'gis_asset';
        });
        this.ctb.attributesData.attributes = this.ctb.attributes;
        this.setAttribute(this.ctb.attributes);
      }
    });
  }

  // get Threshold based on configuration
  getThresholdBasedOnConfiguration() {
    this.thresholdSub$ = this.lightHelperObj.getThresholdBasedOnConfiguration(this.mainScreen).subscribe(async (response) => {
      if (response.code === '200') {
        this.listOfActiveAlertThreshold = await response['data'];
        this.listOfActiveAlertThreshold.forEach(element => {
          element.name = element.name;
          element.selectable = true;
          element.value = element.key
        });
        if(this.listOfActiveAlertThreshold.length == 0){
          this.ctb.attributes = this.ctb.attributesData?.attributes ? cloneDeep(this.ctb.attributesData?.attributes) : [];
          this.ctb.attributes = remove(this.ctb.attributes, function (n) {
            return n.value != 'SHState';
          });
          this.setAttribute(this.ctb.attributes);
        } else{
          this.ctb.attributes = this.ctb.attributesData?.attributes ? cloneDeep(this.ctb.attributesData?.attributes) : [];
          if(this.mainScreen!="transformers"){
            this.ctb.attributesData.values['SHState'] = this.listOfActiveAlertThreshold;
          }else{
            this.ctb.attributesData.values['soh'] = this.listOfActiveAlertThreshold;
          }
        }
      }
    });
  }

  getExternalStreetLIghtFilterData(){
    ['fixtureType', 'nodetype', 'maintenanceCompany', 'fixture_style', 'management_area', 'poleId', 'service_type', 'transformer_type', 'county', 'service_center', 'maintenance_type'].forEach(type => {
      let params = { 
        type: type
       }

      this._nodeService.getStreetLightFilterField(params).subscribe((response: any) => {
        if (response && response.code == 200) {
          const responseData = response?.data ? response?.data : [];  
          const transformedData = responseData.map(element => ({
            name: element,
            selectable: true,
            value: element
          }));

          if(transformedData.length > 0){
            let customFieldsAttribute = this.ctb.attributesData?.attributes?.find((element) => element.value == type);
            if (customFieldsAttribute) {
              this.ctb.attributesData.values[type] = transformedData;
            }
          } else {
            // Remove attribute from attributes array if no data
            this.ctb.attributes = this.ctb.attributesData?.attributes ? cloneDeep(this.ctb.attributesData?.attributes) : [];
            this.ctb.attributes = remove(this.ctb.attributes, (n) => n.value !== type);
            this.ctb.attributesData.attributes = this.ctb.attributes;
            this.setAttribute(this.ctb.attributes);
          }
        }
      });
    });
  }

  // get empty field threshold
  getEmptyFieldThreshold() {
    this.emptyFieldSub$ = this.lightHelperObj.getEmptyFieldThreshold(this.mainScreen).subscribe(async (response) => {
      if (response.code === '200') {
        this.listOfEmptyFields = await response['data'];
        this.listOfEmptyFields.forEach(element => {
          element.selectable = true;
          element.value = element.key
        });
        const alertEventThreshold = this.ctb.attributesData?.values['threshold_type']?.concat(this.listOfEmptyFields);
        this.ctb.attributesData.values['threshold_type'] = alertEventThreshold;
        this.notificationFilter();
      }
    });
  }

  // get Wifi Venue Lists
  getVenueLists() {
    this.venueListSub$ = this.wifiHelperObj.getVenueLists().subscribe(response => {
      const responseData = response['code'] == '200' && response['data'] ? response['data'] : [];
      if (responseData && responseData.length > 0) {
        responseData.forEach(element => {
          const venue = {
            name: element.name,
            value: element.id,
            selectable: true
          };
          this.venues.push(venue);
        });

        let checkVenueAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'venue');
        if (checkVenueAttribute) {
          this.ctb.attributesData.values['venue'] = this.venues;
        }
      } else {
        this.ctb.attributes = this.ctb.attributesData?.attributes ? cloneDeep(this.ctb.attributesData?.attributes) : [];
        this.ctb.attributes = remove(this.ctb.attributes, function (n) {
          return n.value != 'venue';
        });
        this.setAttribute(this.ctb.attributes);
      }
    });
  }



  onFilterBlockExpand() {
    if(this.expandSearchBlock){
      this.expandFilterBlock = false;
      this.expandSearchBlock = false;
    }else{
      this.expandFilterBlock = this.expandFilterBlock != true;
    }
    
    this.searchPlaceHolder();
    if(this.expandFilterBlock){
      this.ctb.attribute = this.ctb.attributeValueInput = null;
      this.ctb.subAttributeDetail = null;
      this.ctb.enableAddAttribute = false;
    }
    if(this.mainScreen == "notifications"){
      this.updateHeight();
      this.ctb.isDateRangeAttributeAdded = false;
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    
    // If element is no longer in DOM (e.g., mat-select option after selection), don't close
    if (!targetElement.isConnected) {
      return;
    }

    // Check if click is inside any CDK overlay (mat-select, mat-autocomplete, mat-datepicker, etc.)
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    const isInsideOverlay = overlayContainer?.contains(targetElement);
    const isInsideComponent = this.eRef.nativeElement.contains(targetElement);

    // Close filter block if clicking outside component and outside overlay
    if (this.expandFilterBlock && !isInsideComponent && !isInsideOverlay) {
      this.expandFilterBlock = false;
      this.expandSearchBlock = false;
    }
    
    // Close search block if clicking outside
    if (this.searchText && !isInsideComponent && !isInsideOverlay) {
      this.expandSearchBlock = false;
    }
    
    // Close when clicking on shadow-filter overlay
    if (targetElement.classList.contains('shadow-filter')) {
      this.expandFilterBlock = false;
      this.expandSearchBlock = false;
    }
  }

  onKeyUpFilterBlockExpand() {
    this.searchPlaceHolder();
    this.expandSearchBlock = this.searchText ? true : false;
    if(this.expandFilterBlock){
      this.ctb.attribute = this.ctb.attributeValueInput = null;
      this.ctb.subAttributeDetail = null;
    }
    if(this.mainScreen == "notifications"){
      this.updateHeight();
      this.ctb.isDateRangeAttributeAdded = false;
    }
  }

  onFilterMenuExpand() {
    this.expandMenuFilter = this.expandMenuFilter == true ? false : true;
  }

  openSavedFilter() {
    this.ctb.openSavedFilter(this.mainScreen);
  }

  saveNodeFilter() {
    this.ctb.saveNodeFilter(this.mainScreen);
  }

  onSearchApply(type = 'search') {    
    let search = this.searchText;
    this.searchText = '';
    this.ctb.onSearchApply(search, type);
    this.expandSearchBlock = false;   
    if(this.mainScreen == "notifications"){
      this.updateHeight();
    }
    this.closeExpandFilterBlock();
  }

  validateNumberInput(event) {
    if (this.ctb.attributeValueInputType === 'number') {
      const pattern = /^[0-9]+$/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }

  validateDecimalCustomKey(event){
    if(event.key === '.'){ 
      event.preventDefault();
    }
  }

  validateVersionInput(event: KeyboardEvent): boolean { 
    const char = event.key; 
    const inputValue = (event.target as HTMLInputElement).value;
    
    // Allow digits and dots only 
    if (!char.match(/[0-9.]/)) { 
      event.preventDefault(); 
      return false; 
    } 

    // Prevent multiple consecutive dots or leading dot 
    if (char === '.' && (inputValue.endsWith('.') || inputValue === '')) { 
      event.preventDefault(); 
      return false; 
    } 
    // Prevent more than two dots in total 
    const dotCount = (inputValue.match(/\./g) || []).length; 
    if (char === '.' && dotCount >= 2) { 
      event.preventDefault(); 
      return false; 
    } 

    const parts = inputValue.split('.'); // If adding a digit, ensure the last segment does not exceed 2 digits 
    if (char.match(/[0-9]/)) { 
      const lastPart = parts[parts.length - 1]; 
      if (lastPart.length >= 2) { 
        event.preventDefault(); 
        return false; 
      } 
    } 

    return true; 
  }


  onRecentSearchClick(filters) {
    this.searchText = '';
    this.expandSearchBlock = false;
    let findLocationSearch = filters[0].payload.find(d => d.attribute === "location_search");
    if (findLocationSearch) {
      if(this.mainScreen == 'notifications'){
        this._topBarConf.locationSearchFilterApplied.next(filters);
      }
      if (isCoordinateLocationSearchValue(findLocationSearch.value)) {
        this._topBarConf.locationSearchFilterApplied.next({
          filter: [],
          searchString: findLocationSearch.value,
          exportFilter: filters,
          filterType: this.mainScreen,
        });
      } else {
        this._mapPlacePredictionsService.redirectMapToSearchLocation(findLocationSearch.value);
      }
    } else {
      this.ctb.filters = [];
      let tagValues = [];
      const pruneResult = this.ctb.pruneInactiveCustomFieldFilters(filters);
      if (pruneResult.pruned) {
        this.notifyInactiveCustomFieldFiltersPruned();
      }
      pruneResult.filters.forEach(filter => {
        filter.name = this.filterTranslate(filter.notTranslatedValue, filter.name)
        if(this.mainScreen == 'notifications'){
          if(filter?.id){
            filter?.payload.forEach(element => {
              this.createFilterForNotifications(element)
            });
          }else{
            this.createFilterForNotifications(filter.payload[0])
          }
        } else if (this.isPowerQualityScreen()) {
          if (filter?.id) {
            filter?.payload.forEach(element => {
              this.createFilterForPowerQuality(element)
            });
          } else {
            this.createFilterForPowerQuality(filter.payload[0])
          }
        } else if (this.mainScreen == preferencesConstant.WORK_ORDER) {
          if (filter?.id) {
            filter?.payload.forEach(element => {
              this.createFilterForWorkOrder(element)
            });
          } else {
            this.createFilterForWorkOrder(filter.payload[0])
          }
        }

        filter.payload?.forEach((ele) => {
          if (ele.attribute == "tag") {
            tagValues.push(ele?.value);
          }
        });
        this._topBarConf.selectedTagOnNodeStatus = tagValues;

        this.ctb.filters.push(filter)

      });
      if (this.ctb.filterChange) {
        this.ctb.onFilterChange(true, true);
      }
    }
    if(this.mainScreen == "notifications"){
      this.updateHeight();
    }
    this.closeExpandFilterBlock()
    
  }

  closeExpandFilterBlock(){
    if(this.expandFilterBlock){
      this.expandFilterBlock = false;
    }
  }

  createFilterForNotifications(filter){
    if(filter?.attribute == 'product_type'){
      this.ctb.selectedProductType = filter?.value;
      this.onChangeOfProductType();
    }else if(filter?.attribute == 'date'){
      const customerTimezone = this._storageService.getStorageItem('customerTimeZone');
      if(filter?.start_date || filter?.end_date){
        this.restoreCustomDateRangeFromFilter(filter?.start_date, filter?.end_date, customerTimezone);
      }else if(filter?.period){
        this.ctb.selectedDateRange = filter?.period;
        this.ctb.startDate = null;
        this.ctb.endDate = null;
      }
    }
  }

  createFilterForPowerQuality(filter) {
    if (filter?.attribute == 'date') {
      const customerTimezone = this._storageService.getStorageItem('customerTimeZone');
      if (filter?.start_date || filter?.end_date) {
        this.restoreCustomDateRangeFromFilter(filter?.start_date, filter?.end_date, customerTimezone);
      } else if (filter?.period) {
        this.ctb.selectedDateRange = filter?.period;
        this.ctb.startDate = null;
        this.ctb.endDate = null;
      }
    }
  }

  createFilterForWorkOrder(filter) {
    if (filter?.attribute == 'date') {
      const customerTimezone = this._storageService.getStorageItem('customerTimeZone');
      if (filter?.start_date || filter?.end_date) {
        this.restoreCustomDateRangeFromFilter(filter?.start_date, filter?.end_date, customerTimezone);
      }
    }
  }

  filterTranslate(filterName, storedName = '') {
    if (filterName) {
      let filter = filterName.split(",");
      let translateWord = [];
      let i = 0;
      filter.forEach(element => {
        let splitedelements = element.split("*");
        let fullstring = '';
        splitedelements.forEach(splitedelement => {
          if (splitedelement.includes('noTranslate:')) {
            fullstring += ' ' + splitedelement.replace('noTranslate:', ''); + ' ';
          } else {
            if(splitedelement == 'Lights' || splitedelement == 'light'){
              fullstring += ' ' + splitedelement + ' ';
            }else{
              fullstring += ' ' + this.ctb.translateAlert(splitedelement) + ' ';
            }
          }

        });
        translateWord.push(fullstring);
        i++;
      });
      return translateWord.join(', ');
    } else {
      return storedName;
    }
  }

  async getPreferences() {
    if (this.preferenceCall == true) {
      const activeScreen = this.mainScreen === 'planning' ? this.subScreen : this.mainScreen;
      const pruned = await this.ctb.getUserPreferences(activeScreen);
      if (pruned) {
        this.notifyInactiveCustomFieldFiltersPruned();
      }
    }
  }

  /**
   * PAN-14179 — product decision (Abir + Florencia): info toast with Configuration deep link.
   */
  private notifyInactiveCustomFieldFiltersPruned(): void {
    const msg = this.translateService.instant('custom_field_filter_no_longer_supported');
    this._globalToastService.displayCustomToastWithUserAction(
      msg,
      'info',
      12000,
      () => this.navigateToCustomFieldsConfiguration(),
      true
    );
  }

  private navigateToCustomFieldsConfiguration(): void {
    const routeByScreen: Record<string, string> = {
      light: '/pages/configuration/lighting',
      aqi: '/pages/configuration/lighting',
      transformers: '/pages/configuration/transformers',
      cameras_video: '/pages/configuration/video-audio',
      wifi: '/pages/configuration/wifi'
    };
    const screen = this.mainScreen || this.ctb.type;
    const route = routeByScreen[screen] || '/pages/configuration/lighting';
    const url = this.router.serializeUrl(
      this.router.createUrlTree([route], { queryParams: { tab: 'custom_fields' } })
    );
    window.open(`${window.location.origin}/#${url}`, '_blank');
  }

  removeFilter(filter, attributeName = null){
    if(this.mainScreen == 'notifications'){
      if(filter?.payload[0].attribute == 'date'){
        this.ctb.initializeDateRangeVariables();
        this.ctb.isCalenderVisible = false;
        this.ctb.selectedDateRange = this.ctb.defaultPeriod;
        this.ctb.removeFilter(filter,attributeName);
      }else if(filter?.payload[0].attribute == 'product_type'){
        this.ctb.onResetFilter("reset");
        this.onChangeOfProductType()
      }else{
        this.ctb.removeFilter(filter,attributeName);
      }
    }else{
      this.ctb.removeFilter(filter,attributeName);
    }

    if(this.ctb?.removeTags.length > 0 && this._topBarConf?.selectedTagOnNodeStatus?.length){
      this.ctb?.removeTags.forEach(element => {
        var index = this._topBarConf?.selectedTagOnNodeStatus.indexOf(element);
        if (index !== -1) {
            this._topBarConf?.selectedTagOnNodeStatus.splice(index, 1);
        }
      });
      // this._topBarConf.removeTagSelection.next(this.ctb.removeTags);
    }

  }

  onResetFilter(){
    if(this.mainScreen == 'notifications'){
      this.ctb.selectedProductType = this._storageService.getStorageItem("availableProductType")[0]?.key;
      this.changeAttributeValueBasedOnProductType();
    }
    this.ctb.onResetFilter();
  }

  getSuggestedFilters() {
    this.ctb.getUserSuggestedFilters(this.mainScreen);
  }

  removeCommaSeparateFilter(filter) {
    this.ctb.removeSeparateFilter(filter);
    if(this.ctb.removeTags.length > 0){
      if(this.ctb?.removeTags.length > 0 && this._topBarConf?.selectedTagOnNodeStatus?.length){
        this.ctb?.removeTags.forEach(element => {
          var index = this._topBarConf?.selectedTagOnNodeStatus.indexOf(element);
          if (index !== -1) {
              this._topBarConf?.selectedTagOnNodeStatus.splice(index, 1);
          }
        });
        // this._topBarConf.removeTagSelection.next(this.ctb.removeTags);
      }
    }

  }

  onAttributeClick(filter, attribute = null, attributeValue = null) {
    this.ctb.onAttributeClicks(filter, attribute, attributeValue);
  }
  subscribeTagCreationFilter() {
    this.nodeSelectionSub$ = this._topBarConf.nodeSelectionFilter.subscribe(value => {
      if (!isEmpty(value) && value.length !== 0) {
        // Change the product type based on what is being filtered
        if (this.mainScreen == "notifications") {
          this.onChangeOfProductType();
        }
        this.preferenceCall = false;
        this.ctb.search = null;
        if (value.hasOwnProperty("is_outside_set")) {
          if (value?.is_outside_set) {
            this.ctb.filters = [];
            if(this.isPowerQualityScreen()){
              this.ctb.addDefaultPeriodChip();
            }
          } else {
            const index = this.ctb.filters.findIndex(filter => filter.name.includes("Selection"));
            if (index >= 0) {
              this.ctb.filters.splice(index, 1);
            }
          }
          this.ctb.filters = remove(this.ctb.filters, function (n) {
            if (n.is_outside_set == false) {
              return !n;
            } else {
              return n;
            }
          });
          this.ctb?.filters.push(value);
        } else {
          this.ctb.filters = [];
          value?.forEach(nodeSelectionFilter => {
            this.ctb?.filters.push(nodeSelectionFilter);
          });
          if(this.isPowerQualityScreen()){
            this.ctb.addDefaultPeriodChip();
          }
        }
        this.ctb.onFilterChange(true);
      }
    });
  }

  addTagFilter() {
    this.tagSelectionSub$ = this._topBarConf?.addTagSelectionFilter?.subscribe(value => {
      if (!isEmpty(value) && value?.length !== 0) {
        this.ctb.filterChange = false;
        if(this.mainScreen == 'notifications'){
          this.ctb.checkProductTypeChipAvailable();
          this.ctb.addNotificationsChip(false);
        }
        this.ctb.filters.forEach((element,key) => {
          if(element?.payload[0]?.attribute == 'tag'){
            this.ctb.filters.splice(key);
          }
        });
        value?.forEach(element => {
          this.ctb.addAttributeToFilters('tag', '=', element);
        });
        this.ctb.filterChange = true;
        this.ctb.onFilterChange(true);
      } else if (isEmpty(value) && !this._topBarConf?.selectedTagOnNodeStatus?.length && this.ctb?.filters?.length) {
        this.ctb.filterChange = false;
        this.ctb.filters.forEach((element,key) => {
          if(element?.payload[0]?.attribute == 'tag'){
            this.ctb.filters.splice(key);
          }
        });
        this.ctb.filterChange = true;
      }
    });
  }

  subscribeNodeStatusFilter() {
    this.nodeStatusSub$ = this._topBarConf?.addNodeStatusFilter?.subscribe(value => {
      const isMatch = this.ctb.filters.some(item =>
        item.payload.some(p => p.value === value)
      );
      if(isMatch) return;
      let currentNodeStatusConfig = cloneDeep(this._topBarConf?.currTopBarConfig?.value?.node_status);
      let filterObj;
      let payload;
      let pushedObj = [];
      if (!isEmpty(value)) {
        let targetValue = currentNodeStatusConfig?.legends?.find((ele) => ele.key == value);        
        if (value === 'with_work_order' || value === 'without_work_order') {
          currentNodeStatusConfig.label = currentNodeStatusConfig.attribute;
          targetValue.key = (value === 'with_work_order') ? 'yes' : 'no';

          // Remove any existing 'with_work_order' or 'without_work_order' filters
          this.ctb.filters = this.ctb.filters.filter(existingFilter => {
            const payloadAttribute = existingFilter.payload?.[0]?.attribute;
            const payloadValue = existingFilter.payload?.[0]?.value;
            return !(payloadAttribute === currentNodeStatusConfig.attribute && (payloadValue === 'yes' || payloadValue === 'no'));
          });
        }    
        payload = {
          'attribute': currentNodeStatusConfig?.attribute || null,
          'operator': "=",
          'value': targetValue?.key.toString()
        }

        filterObj = {
          'name': this.translateService.instant(currentNodeStatusConfig?.label || 'status') + ' = ' + this.translateService.instant(targetValue?.filter_label?.toString()),
          'notTranslatedValue': currentNodeStatusConfig?.label +'*=*' + targetValue?.filter_label?.toString() || 'status' +'*=*' + targetValue?.filter_label?.toString(),
          'payload': new Array(payload)
        }
        pushedObj.push(filterObj);
        pushedObj.forEach(filter => {
          if (this.ctb.filters.every(x => x.name !== filter.name)) {
            this.ctb.filters.push(filter);
          }
        });
        this.ctb.onFilterChange(true, true);
      }
    });
  }

  subscribeTxTypeFilter() {
    this.txTypeStatusSub$ = this._topBarConf?.addTxTypeFilter?.subscribe(value => {
      let filterObj;
      let payloadArray = [];
      let pushedObj = [];
      if (!isEmpty(value)) {
        // Remove existing transformer_type filters first
        this.ctb.filters = this.ctb.filters.filter(existingFilter => {
          return !existingFilter.payload?.some(p => p.attribute === 'transformer_type');
        });

        // Create separate filter objects based on txType value
        if (value?.value?.toLowerCase() === 'aerial') {
          const aerialTypes = [
            { value: 'aerial_1p', label: '1p_aerial' },
            { value: 'aerial_3p', label: '3p_aerial' },
            { value: 'unknown', label: 'Unknown' }
          ];

          aerialTypes.forEach(type => {
            const filterObj = {
              'name': this.translateService.instant('transformer_type') + ' = ' + this.translateService.instant(type.label),
              'notTranslatedValue': 'transformer_type*=*' + this.translateService.instant(type.label),
              'payload': [{
                'attribute': 'transformer_type',
                'operator': "=",
                'value': type.value
              }]
            };
            pushedObj.push(filterObj);
          });

        } else if (value?.value?.toLowerCase() === 'pad') {
          const padTypes = [
            { value: 'pad_1p', label: '1p_padmount' },
            { value: 'pad_3p', label: '3p_padmount' }
          ];

          padTypes.forEach(type => {
            const filterObj = {
              'name': this.translateService.instant('transformer_type') + ' = ' + this.translateService.instant(type.label),
              'notTranslatedValue': 'transformer_type*=*' + this.translateService.instant(type.label),
              'payload': [{
                'attribute': 'transformer_type',
                'operator': "=",
                'value': type.value
              }]
            };
            pushedObj.push(filterObj);
          });

        } else {
          // Default case for other transformer types
          const filterObj = {
            'name': this.translateService.instant(value.key || 'status') + ' = ' + this.translateService.instant(value?.filter_label?.toString()),
            'notTranslatedValue': value.key + '*=*' + this.translateService.instant(value?.filter_label?.toString()) || 'status*=*' + this.translateService.instant(value?.filter_label?.toString()),
            'payload': [{
              'attribute': value.key || 'transformer_type',
              'operator': "=",
              'value': value?.value
            }]
          };
          pushedObj.push(filterObj);
        }
        
        pushedObj.forEach(filter => {
          if (this.ctb.filters.every(x => x.name !== filter.name)) {
            this.ctb.filters.push(filter);
          }
        });
        this.ctb.onFilterChange(true, true);
      }
    });
  }
  
  subscribeDashBoardInsightFilter() {
    this.activatedRoute.queryParams.subscribe(params => {
      const customerTimezone = this._storageService.getStorageItem('customerTimeZone');
      if(params?.selectSingleRecordFromList && params?.node_id){
        this.ctb.onSearchApply(params?.node_id, "search");
      }
      
      if(params?.attribute){
        this.preferenceCall = false;
        this.ctb.attribute =  params.attribute;
        this.ctb.attributeValue =  [...params.attributeValue];
        this.ctb.selectedProductType =  params.selectedProductType;
        this.ctb.selectedDateRange =  params.selectedDateRange;

        if (params?.startDate) {
          const [year, month, day] = params.startDate.split('-').map(Number);
          this.ctb.startDate = new NgbDate(year, month, day);
        }

        if (params?.startTime) {
          this.ctb.startTime = params.startTime;
        }

        if (params?.endDate) {
          const [year, month, day] = params.endDate.split('-').map(Number);
          this.ctb.endDate = new NgbDate(year, month, day);
        }
        if (params?.endTime) {
          this.ctb.endTime = params.endTime;
        }

        if(params?.startTime && params?.endTime){
          if(!(params?.startTime == '00:00' && params?.endTime == '23:59')){
            this.ctb.allDaySelected = false;
          }
        }

        // Defer chip creation until translations are loaded so the product type and
        // date chips render their translated labels (e.g. "Product Type = Light",
        // "Date = Now") instead of the raw keys when navigating from a dashboard tile.
        this.translateService.get('product_type').subscribe(() => {
          let pushedObj = [];
          this.ctb.addNotificationsChip();
          const payload = {
            'attribute': params.attribute,
            'operator': params.operator,
            'value': params.attributeValue
          }

          const filterObj = {
            'name': params.name,
            'notTranslatedValue': params.notTranslatedValue,
            'payload': new Array(payload)
          }

          pushedObj.push(filterObj);
          if(params['extraFilterObject']){
            const filterObj = JSON.parse(params['extraFilterObject']) || null;
            pushedObj.push(filterObj)
          }
          pushedObj.forEach(filter => {
            if (this.ctb.filters.every(x => x.name !== filter.name)) {
              this.ctb.filters.push(filter);
            }
          });
          this.ctb.onFilterChange(false, true, false);
          this.updateHeight();
          this.ctb.savePreferences();
          this.router.navigate([], {
            queryParams: {},
            replaceUrl: true,
          });
        });
      }
    
      if(this.mainScreen.includes(preferencesConstant.POWER_QUALITY) && params?.selectedDateRange){
        this.ctb.selectedDateRange =  params.selectedDateRange;
        this.ctb.addNotificationsChip();
        this.ctb.onFilterChange(false, true, false);
        this.ctb.savePreferences();
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true,
        });
      }
    });

      
  }

  getFilterTagParams() {
    this.filterTagParamsSub$ = this._topBarConf.filterTagParams.subscribe(value => {
      if (!isEmpty(value)) {
        this.ctb.filters = [];
        this.preferenceCall = false;
        value?.forEach(filteredTagParams => {
          this.ctb.filters.push(filteredTagParams);
        });
        this.ctb.onFilterChange(true, false);
      }
    });
  }

  notificationFilter() {
    this.notificationFilterSub$ = this._topBarConf?.notificationFilter?.subscribe(value => {
      if (!isEmpty(value)) {
        this.ctb.filters = [];
        this.preferenceCall = false;
        this.ctb.notificationParams = value;
        this.ctb.addNotificationTypeToFilter();
      }
    });
  }
  getCurrentUserDetails() {
    this.currentUserDetailsSub$ = this.lightHelperObj.getCurrentUserDetails().subscribe(async currentUserDetail => {
      if (currentUserDetail?.data) {

        if (currentUserDetail?.data?.temperature_in_celcius == 0 && this.mainScreen == 'aqi') {
          this.ctb.attributes = remove(this.ctb.attributes, function (n) {
            return n.value != 'temperature_c';
          });
        }
        else if (currentUserDetail?.data?.temperature_in_celcius == 1 && this.mainScreen == 'aqi') {
          this.ctb.attributes = remove(this.ctb.attributes, function (n) {
            return n.value != 'temperature_f';
          });
        }
      }
      this.setAttribute(this.ctb.attributes);  // set attributes
    });
  }

  subscribeActiveAlerts() {
    this.activeAlertSub$ = this._topBarConf.activeAlertsFilter.subscribe(value => {
      if (!isEmpty(value)) {
        if (this.mainScreen == 'transformers') {
          if (this.ctb.activeAlertsParams.find(ob => ob['alert_type'] === value.alert_type)) {
          } else {
            this.ctb.activeAlertsParams.push(value);
          }
        } else {
          if (this.ctb.activeAlertsParams.find(ob => ob['SHState'] === value.SHState)) {
          } else {
            this.ctb.activeAlertsParams.push(value);
          }
        }
        this.ctb.addActiveAlertsTypeFilter(this.mainScreen);
      }
    });
  }

  subscribeExceptionEvents() {
    this.alertEventSub$ = this._topBarConf.exceptionEventsFilter.subscribe(value => {
      if (!isEmpty(value)) {
        if (value.notification_deleted === true) {
          this.ctb.notificationParams = value;
        } else if (value) {
          this.ctb.notificationParams = value;
        } else {
          // this.onFilterApplied();
        }

        this.ctb.addExceptionTypeToFilter();
      }
    });
  }

  subscribeDigitalInspectionPeriodFilter() {
    if (!['light', 'transformers'].includes(this.mainScreen)) {
      return;
    }

    if (this.digitalInspectionPrefSub$) {
      this.digitalInspectionPrefSub$.unsubscribe();
    }
    this.digitalInspectionPrefSub$ = this._sharedService.mapDigitalInspectionPreferenceSubject.subscribe((enabled) => {
      if (enabled) {
        this.ctb.addDigitalInspectionPeriodChip();
      } else {
        this.ctb.removeDigitalInspectionPeriodChip();
      }
    });

    if (this.digitalInspectionPeriodSub$) {
      this.digitalInspectionPeriodSub$.unsubscribe();
    }
    // Draw the chip once for the persisted period (the stateless notifier does not replay).
    if (this._sharedService.mapDigitalInspectionPreferenceSubject.value) {
      this.ctb.addDigitalInspectionPeriodChip();
    }
    this.digitalInspectionPeriodSub$ = UsersPreferencesUtils.digitalInspectionPeriodChanged$.subscribe(() => {
      if (this._sharedService.mapDigitalInspectionPreferenceSubject.value) {
        this.ctb.addDigitalInspectionPeriodChip(false);
      }
    });
  }

  selectedNotificationFilter() {
    this.selectedNotificationFilterSub$ = this._topBarConf?.selectedNotificationFilter?.subscribe(value => {
      if (value == true) {
        this.ctb.filters = [];
        this.ctb.onFilterChange(true, false);
        this.preferenceCall = false;
      }
    });
  }

  deleteNotificationFilter(){
    this.deleteNotificationFilter$ = this._topBarConf?.deleteNotificationFilter?.subscribe(value => {
      if (!isEmpty(value)) {
        if (value.notification_deleted === true) {
          this.ctb.notificationParams = value;
        }
        this.ctb.addNotificationTypeToFilter();
      }
    });
  }

  getCustomerTimeZone() {
    const params = {
      "customer_id": JSON.parse(this._storageService.getItem('customerId')) || null,
      "subpanel_id": JSON.parse(this._storageService.getItem('subpanelId')) || null,
    }
    this.customerTimeZoneSub$ = this.lightHelperObj.getCustomerTimeZone(params).subscribe(async customerTimeZone => {
      if (customerTimeZone['status'] === 'success') {
        this.ctb.customerTimezoneDetails = customerTimeZone['data'] ? customerTimeZone['data'] : this._storageService.getStorageItem('customerTimeZone') ? this._storageService.getStorageItem('customerTimeZone') : 'UTC';
      }
    });
  }

  getTotalNodeCount() {
    if (this.isPowerQualityScreen()) {
      this.totalNodeCount$ = this._topBarConf.transformerNodeCountForPQ.subscribe(res => {
        this.totalNodesCount = Number(res) || 0;
      })
      return;
    }

    this.totalNodeCount$ = this._topBarConf?.nodeCount?.subscribe(value => {
      this.totalNodesCount = Number(value) || 0;
    })
  }

  updateThresholdConfiguration() {
    this.updateThresholdConfiguration$ = this._topBarConf?.updateThresholdsConfigurations?.subscribe(value => {
      if(!isEmpty(value)){
        this.getThresholdBasedOnConfiguration();
      }
    });
  }

  getUserFilter() {
    this.ctb.getUserFilter(null,this.mainScreen);
  }

  // function for input search event change
  onSearchChange(event: Event): void {
    this.expandFilterBlock = false;
    const inputValue = (event.target as HTMLInputElement).value;
    if (this.isCoordinateSearchActive) {
      this.searchInput$.next(inputValue);
    } else {
      this.coordinateSearchRow = null;
    }
    this._mapPlacePredictionsService.onPlaceInputChange(inputValue).then(data => {
      this.placePredictions = data;
    });
  }

  onCoordinateRowClicked(row: CoordinateDropdownRow): void {
    this.searchText = buildCoordinateLocationPayload(
      row.lat,
      row.lng,
      row.displayLabel
    );
    this.onSearchApply('location_search');
    this.coordinateSearchRow = null;
    if (this.mainScreen == 'notifications') {
      this.updateHeight();
    }
  }

  hasLocationSearchResults(): boolean {
    return (
      !!this.coordinateSearchRow ||
      (this.placePredictions?.length ?? 0) > 0
    );
  }

  openSearchWindow(){
    this.expandSearchBlock = this.searchText ? true : false;
    if (this.isCoordinateSearchActive && this.searchText) {
      this.searchInput$.next(this.searchText);
    }
  }

  // function for clicked of location prediction search
  onPlaceOfLocationClicked(prediction: any): void {
      this._mapPlacePredictionsService.getLocationByPlaceId(prediction.place_id).then(data => {
        let payload = (data && data['location'].lat()) ? {'lat': data['location'].lat(),'lng': data['location'].lng(), name: prediction.description,'viewport' : data['viewport']} : '';
        if(payload) {
          this.searchText = JSON.stringify(payload);
          this.onSearchApply('location_search');
        }
    });
    if(this.mainScreen == "notifications"){
      this.updateHeight();
    }
  }

  isLocationSearch(filter: any): any {
    if(filter?.length){
      return filter[0].payload.find(data => data.attribute === 'location_search')
    }
    return undefined;
  }

  disableRemoveFilter(filterPayload) {
    return filterPayload?.period != 'last_7_day' 
  }

  private subscribeCoordinateLocationSearch(): void {
    this.coordinateLocationSearchSub = this._topBarConf.locationSearchFilterApplied.subscribe(
      (value) => {
        if (isEmpty(value)) {
          return;
        }
        const locationValue = extractLocationSearchValue(value.exportFilter);
        if (!locationValue) {
          return;
        }
        const context = this.getCoordinateMapContext();
        if (isCoordinateLocationSearchValue(locationValue)) {
          this._coordinateMapController.handleCoordinateSelection(locationValue, context);
        } else {
          this._coordinateMapController.clearCoordinatePointer();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.coordinateSearchSub?.unsubscribe();
    this.coordinateLocationSearchSub?.unsubscribe();
    this._coordinateMapController.clearCoordinatePointer();
    this.searchInput$.complete();
    this.txTypeStatusSub$?.unsubscribe();
    this.dynamicSearchBarSub$?.unsubscribe();
    if (this.currentFilterSub$) {
      this.currentFilterSub$.unsubscribe();
    }
    if(this.ctb.usersSuggestedFiltersSub) {
      this.ctb.usersSuggestedFiltersSub.unsubscribe();
    }
    if(this.ctb.recentFilterSub) {
        this.ctb.recentFilterSub.unsubscribe();
    }
    if(this.ctb.suggestedFiltersSub) {
        this.ctb.suggestedFiltersSub.unsubscribe();
    }
    if (this.customFiledSub$) {
      this.customFiledSub$?.unsubscribe();
    }
    this.tiltStatusValue?.unsubscribe();
    this.pqStatusValue?.unsubscribe();
    
    if (this.tagListChangeDetect$) {
      this.tagListChangeDetect$.unsubscribe();
    }
    if (this.currentUserDetailsSub$) {
      this.currentUserDetailsSub$?.unsubscribe();
    }

    if (this.thresholdSub$) {
      this.thresholdSub$?.unsubscribe();
    }
    if (this.emptyFieldSub$) {
      this.emptyFieldSub$?.unsubscribe();
    }
    if (this.hardwareSub$) {
      this.hardwareSub$?.unsubscribe();
    }
    if (this.txHardwareVersionsSub$) {
      this.txHardwareVersionsSub$?.unsubscribe();
    }

    if (this.venueListSub$) {
      this.venueListSub$?.unsubscribe();
    }

    if (this.gisAssetsSub$) {
      this.gisAssetsSub$?.unsubscribe();
    }

    if (this.tagListSub$) {
      this.tagListSub$?.unsubscribe();
    }


    if (this.nodeSelectionSub$) {
      this.nodeSelectionSub$?.unsubscribe();
    }

    if (this.tagSelectionSub$) {
      this.tagSelectionSub$?.unsubscribe();
    }

    if (this.nodeStatusSub$) {
      this.nodeStatusSub$?.unsubscribe();
    }

    if (this.activeAlertSub$) {
      this.activeAlertSub$?.unsubscribe();
    }

    if (this.alertEventSub$) {
      this.alertEventSub$?.unsubscribe();
    }

    if (this.digitalInspectionPrefSub$) {
      this.digitalInspectionPrefSub$?.unsubscribe();
    }

    if (this.digitalInspectionPeriodSub$) {
      this.digitalInspectionPeriodSub$?.unsubscribe();
    }

    if (this.customerTimeZoneSub$) {
      this.customerTimeZoneSub$?.unsubscribe();
    }

    if (this.totalNodeCount$) {
      this.totalNodeCount$?.unsubscribe();
    }

    if (this.filterTagParamsSub$) {
      this.filterTagParamsSub$?.unsubscribe();
    }

    if (this.notificationFilterSub$) {
      this.notificationFilterSub$?.unsubscribe();
    }

    if (this.selectedNotificationFilterSub$) {
      this.selectedNotificationFilterSub$?.unsubscribe();
    }

    if (this.updateThresholdConfiguration$) {
      this.updateThresholdConfiguration$.unsubscribe();
    }

    if(this.deleteNotificationFilter$){
      this.deleteNotificationFilter$.unsubscribe();
    }

    if(this.notificationAlertListSub$){
      this.notificationAlertListSub$.unsubscribe();
    }

    if(this.notificationExceptionsListSub$){
      this.notificationExceptionsListSub$.unsubscribe();
    }

    if(this.notificationsHWVersionSub$){
      this.notificationsHWVersionSub$.unsubscribe();
    }

    if(this.formerCableKitsSub$){
      this.formerCableKitsSub$.unsubscribe();
    }

    if(this.savedFilterAppliedForNotificationsSub$){
      this.savedFilterAppliedForNotificationsSub$.unsubscribe();
    }

    if(this.getFilterOnRefreshForNotificationSub$){
      this.getFilterOnRefreshForNotificationSub$.unsubscribe();
    }
    
    if(this.savedFilterAppliedForPowerQualitySub$){
      this.savedFilterAppliedForPowerQualitySub$.unsubscribe();
    }

    if(this.getFilterOnRefreshForPowerQualitySub$){
      this.getFilterOnRefreshForPowerQualitySub$.unsubscribe();
    }

    if (this.viewNodeFilterSub$) {
      this.viewNodeFilterSub$?.unsubscribe();
    }

    this.ctb.destroyAllVariable();
    this._topBarConf?.nodeCount?.next(0);
    this._topBarConf?.addNodeStatusFilter?.next('');
    this._topBarConf?.filterApplied?.next({});
    this._topBarConf?.activeAlertsFilter.next({});
    this._topBarConf?.alertEventsFilter.next({});
    this._topBarConf?.nodeSelectionFilter.next([]);
    this._topBarConf?.removeTagSelection.next([]);
    this._topBarConf?.addTagSelectionFilter.next([]);
    this._topBarConf?.savedPreferenceTag.next({});
    this._topBarConf?.nodeSelection.next({});
    this._topBarConf?.expandTagBlock.next({});
    this._topBarConf?.filterTagParams.next({});
    this._topBarConf?.notificationFilter.next({});
    this._topBarConf?.selectedNotificationFilter.next(false);
    this._topBarConf?.updateThresholdsConfigurations.next(null);
    this._topBarConf?.tagResponseChanged.next(false);
    this._topBarConf?.tagFilterUpdate.next(false);
    this._topBarConf?.deleteNotificationFilter.next({});
    this._topBarConf?.currentFilterConfiguration.next({});
    this._topBarConf?.viewNodeFilter.next(null);
    this._topBarConf?.savedFilterAppliedForWorkOrder.next({});
    if((this.mainScreen == 'notifications') || this.isPowerQualityScreen()){
      this._topBarConf.filterApplied.next({});
      this._topBarConf?.savedFilterAppliedForNotifications.next({});
      this._topBarConf?.getFilterOnRefreshForNotification.next({});
      this._topBarConf?.savedFilterAppliedForPowerQuality.next({});
      this._topBarConf?.getFilterOnRefreshForPowerQuality.next({});
      this.ctb.isCalenderVisible = false;
      this.ctb.selectedDateRange = this.ctb.defaultPeriod;
    }
    if(this.currentModeSelectionSub){
      this.currentModeSelectionSub.unsubscribe();
    }
  }

  mouseEvent() {
    // let activeElement = <HTMLElement>document.activeElement;
    // activeElement.blur();
  }

  onChangeOfProductType(event?) {
    if(event){
      this.ctb.enableAddAttribute = true;
      this.ctb.attribute = this.ctb.attributeValueInput= null;
    }

    this.changeAttributeValueBasedOnProductType();
  }

  // all the api calls and hide and disable, enable attribute based on product type change
  changeAttributeValueBasedOnProductType(){
    this.getHWVersionListForNotifications(this.ctb.selectedProductType);
    this.getCableKitListForNotifications(this.ctb.selectedProductType);
    this.getAlertTypeListForNotification(this.ctb.selectedProductType);

    const isCustomFieldDisable = ['all_products', 'aqi'].includes(this.ctb.selectedProductType);
    const isCustomFieldHidden = ['aqi','tilt_monitoring'].includes(this.ctb.selectedProductType);
    const isWorkOrderDisplay = (Array.isArray(this.ctb.productTypes) && this.ctb.productTypes.some(pt => pt.key === 'light' || pt.key === 'cameras_video')) && ['all_products', 'light', 'cameras_video'].includes(this.ctb.selectedProductType);

    const isAllProducts = this.ctb.selectedProductType === 'all_products';
    const isTransformers = this.ctb.selectedProductType === 'transformers';
    const isTiltMonitoring = this.ctb.selectedProductType === 'tilt_monitoring';

    this.ctb.attributes?.forEach(element => {
      if (element.value === 'custom_field') {
        element.disable = isCustomFieldDisable;
        element.hidden = isCustomFieldHidden;
        element.name = isCustomFieldDisable ? 'custom_field_disable' : 'custom_fields';
      }

      const transformerValues = ['kva', 'substation', 'substation_id', 'feeder', 'feeder_id', 'transformer_type', 'cableKit'];
      const tiltMonitoringValues = ['substation', 'substation_id', 'feeder', 'feeder_id', 'tiltAngleZNorm', 'lateral_id'];
      const isInTransformer = transformerValues.includes(element.value);
      const isInTiltMonitoring = tiltMonitoringValues.includes(element.value);

      if (isInTransformer || isInTiltMonitoring) {
        const shouldShow =
          (isInTransformer && isTransformers) ||
          (isInTiltMonitoring && isTiltMonitoring);
        element.hidden = !shouldShow;
      }

    const wordOrderValues = ['open_work_order', 'work_order_id'];
    if(wordOrderValues.includes(element.value)){
      element.disable = !isWorkOrderDisplay;
      if(element.value === 'open_work_order') {
        element.name = isWorkOrderDisplay ? 'open_work_order' : 'open_work_order_feature_in_development';
      }else if(element.value === 'work_order_id') {
        element.name = isWorkOrderDisplay ? 'work_order_id' : 'work_order_id_feature_in_development';
      }
    }

    });

    if (!isCustomFieldDisable) {
      this.getCustomFields(this.ctb.selectedProductType);
    }else{
      const isSubPanelEnabled = this._storageService.getStorageItem('isSubpanelEnabled') ? true : false;
      const isMasterSubPanel = this._storageService.getStorageItem('masterSubpanelsSelected') ? true : false;
      const isMultipleSubPanel = this._storageService.getStorageItem('multiSubpanelsSelected') ? true : false;      
      if(isSubPanelEnabled && (isMasterSubPanel || isMultipleSubPanel)){
        this.ctb.attributes = this.ctb.attributes ? cloneDeep(this.ctb.attributes) : [];
        this.ctb.attributes = remove(this.ctb.attributes, function (n) {
          return n.value != 'custom_field';
        });
        this.ctb.attributesData.attributes = this.ctb.attributes;
        this.setAttribute(this.ctb.attributes);
      }
    }

    if (!isAllProducts) {
      this.getTagListBasedOnProductTypeForNotification(this.ctb.selectedProductType);
    }else{
      this._topBarConf.loadTagComponent = true;
    }    
  }

  // get Hardware Version Lists
  getHWVersionListForNotifications(productType) {
    this.hardwareVersions = [];
    if (this.mainScreen == 'notifications') {
      this.notificationsHWVersionSub$ = this.ctb.getAllHWListForNotifications().subscribe((response) => {
        const responseData = response['code'] == '200' && response?.data ? response?.data[productType] : [];
        responseData.sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1);
        responseData.forEach(element => {
          const hardwareVersion = {
            name: element,
            value: element,
            selectable: true
          };
          this.hardwareVersions.push(hardwareVersion);
        });
      });
    }

    let hardwareVersionAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'hw_version');
    this.hardwareVersions = this.hardwareVersions.sort((a, b) => (a.name > b.name ? 1 : -1));
    if (hardwareVersionAttribute) {
      this.ctb.attributesData.values['hw_version'] = this.hardwareVersions;
    }
  }

  getCableKitListForNotifications(productType) {
    if (this.formerCableKitsSub$) {
      this.formerCableKitsSub$.unsubscribe();
    }
    this.transformerCableKits = [];
    if (productType == 'transformers') {
      this.formerCableKitsSub$ = this.ctb.getCableKitList().subscribe((response) => {
        const responseData = response['code'] == '200' ? response?.data : [];
        responseData.forEach(element => {
          const transformerCableKit = {
            name: (typeof element == 'number') ? element.toString() : element,
            value: element,
            selectable: true
          };
          this.transformerCableKits.push(transformerCableKit);
        });
      });

      let transformerCableKitsAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'cableKit');
      if (transformerCableKitsAttribute) {
        this.ctb.attributesData.values['cableKit'] = this.transformerCableKits;
      }
    }
  }

  // get Hardware Version Lists
  getAlertTypeListForNotification(productType) {
    let selectedLang = this._storageService.getStorageItem('lang')
    if (this.mainScreen == 'notifications') {
      this.notificationAlertListSub$ = this.ctb.getAllAlertTypeList().subscribe((response) => {
        const responseData = response['code'] == '200' && response?.data ? response?.data[productType] : [];
        responseData.sort((a, b) => a?.name['en'].toLowerCase() > b?.name['en'].toLowerCase() ? 1 : -1);
        this.notificationAlertsList = [];
        responseData.forEach(element => {
          const  notificationAlert= {
            name: element?.name[selectedLang],
            value: element?.threshold_type,
            selectable: true
          };
          this.notificationAlertsList.push(notificationAlert);
        });
        let notificationsAlertAttribute = this.ctb.attributesData?.attributes?.find((element) => element.value == 'threshold_type');
        this.notificationAlertsList = this.notificationAlertsList.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (notificationsAlertAttribute) {
          this.ctb.attributesData.values['threshold_type'] = this.notificationAlertsList;
        }
      });
    }

  }

  onDateRangeChange(event){
    this.ctb.isCalenderVisible = false;
    this.ctb.initializeDateRangeVariables();
    //this.ctb.isDateRangeAttributeAdded = true;
    this.ctb.addDateRangeToFilter();
    (window as any).dataLayer.push({
      dateRange: this.ctb.selectedDateRange
    })
  }

  onSelectDateRangeFromCal(){
    this.ctb.isCalenderVisible = !this.ctb.isCalenderVisible;
    this.ctb.selectedDateRange = null; 
    // this.ctb.initializeDateRangeVariables();
    (window as any).dataLayer.push({
      dateRange: 'custom'
    })
  }

  allDayToggle(event){
    this.ctb.allDaySelected = event.checked;
	  this.formDateChanged = true;
    if(this.ctb.allDaySelected) {
      this.ctb.startTime = '00:00';
      this.ctb.endTime = '23:59';
    } else {
      this.ctb.startTime = '00:00';
      this.ctb.endTime = DateTimeCore.format(DateTimeCore.now(DateTimeCore.guessZone()), DateTimeFormats.TIME_24);
    }
  }

  onChangeStartDate($event: NgbDate) {
    this.ctb.startDate = $event;
    if(this.isPowerQualityTemporalViewEnable){
      this.ctb.isDateRangeAttributeAdded = false;
    }
    if (!(this.ctb?.startDate == this.prevStartDate && this.ctb?.endDate == this.prevEndDate)) {
      this.prevStartDate = this.ctb?.startDate;
      this.prevEndDate = this.ctb?.endDate;
    }
  }

  onChangeEndDate($event: NgbDate) {
    this.ctb.isDateRangeAttributeAdded = true;
    this.ctb.endDate = $event;
  }

  onChangeStartTime(){
  }

  onChangeEndTime(){
  }

  getTagListBasedOnProductTypeForNotification(type){
    this._topBarConf.loadTagComponent = true;
    this.tagListSub$ = this.ctb.getTagList(type)?.subscribe(response => {
      this._topBarConf.tagListResponse = response;
      this.setTagListValue();
    });
  }

  subscribeNotificationsSavedFilter(){
    if(this.savedFilterAppliedForNotificationsSub$){
      this.savedFilterAppliedForNotificationsSub$.unsubscribe();
    }
    this.savedFilterAppliedForNotificationsSub$ = this._topBarConf.savedFilterAppliedForNotifications.subscribe(value => {
      if(!isEmpty(value) && (this.mainScreen == 'notifications')){
        if(this.ctb.filters.length){
          this.ctb.filters[0]?.payload.forEach(filter => {  
            this.createFilterForNotifications(filter)
          });
        }else{
          this.ctb.selectedProductType = this._storageService.getStorageItem("availableProductType")[0]?.key;
          this.ctb.selectedDateRange = this.ctb.defaultPeriod
          this.ctb.initializeDateRangeVariables();
        }
       
        this.ctb.onFilterChange();
        if (this.ctb.selectedDateRange)
          (window as any).dataLayer.push({
            dateRange: this.ctb.selectedDateRange
          })
      }

    });
  }

  subscribePowerQualitySavedFilter() {
    if (this.savedFilterAppliedForPowerQualitySub$) {
      this.savedFilterAppliedForPowerQualitySub$.unsubscribe();
    }
    this.savedFilterAppliedForPowerQualitySub$ = this._topBarConf.savedFilterAppliedForPowerQuality.subscribe(value => {
      if (!isEmpty(value) && this.isPowerQualityScreen()) {
        if (this.ctb.filters.length) {
          this.ctb.filters[0]?.payload.forEach(filter => {
            this.createFilterForPowerQuality(filter)
          });
        } else {
          this.ctb.selectedDateRange = this.ctb.defaultPeriod
          this.ctb.initializeDateRangeVariables();
        }

        this.ctb.onFilterChange();
        if (this.ctb.selectedDateRange)
          (window as any).dataLayer.push({
            dateRange: this.ctb.selectedDateRange
          })
      }
    });
  }

  subscribeWorkOrderSavedFilter() {
    if (this.savedFilterAppliedForWorkOrderSub$) {
      this.savedFilterAppliedForWorkOrderSub$.unsubscribe();
    }
    this.savedFilterAppliedForWorkOrderSub$ = this._topBarConf.savedFilterAppliedForWorkOrder.subscribe(value => {
      if (!isEmpty(value) && this.mainScreen == preferencesConstant.WORK_ORDER) {
        if (this.ctb.filters.length) {
          this.ctb.filters[0]?.payload.forEach(filter => {
            this.createFilterForWorkOrder(filter)
          });
        }
        this.ctb.onFilterChange();
      }
    });
  }

  subscribeNotificationGetFilterOnRefresh(){
    if(this.getFilterOnRefreshForNotificationSub$){
      this.getFilterOnRefreshForNotificationSub$.unsubscribe();
    }
    this.getFilterOnRefreshForNotificationSub$ = this._topBarConf.getFilterOnRefreshForNotification.subscribe(value => {
      if(this.mainScreen == 'notifications' && value && JSON.stringify(value) !== "{}"){
        this.ctb.filters.forEach(element => {
          if(element?.id){
            element?.payload.forEach(element => {
              this.createFilterForNotifications(element);
            });
          }else{
            this.createFilterForNotifications(element?.payload[0])
          }
        });
        this.ctb.onFilterChange(false, true);
      }
    });
  }

  subscribePowerQualityGetFilterOnRefresh(){
    if(this.getFilterOnRefreshForPowerQualitySub$){
      this.getFilterOnRefreshForPowerQualitySub$.unsubscribe();
    }
    this.getFilterOnRefreshForPowerQualitySub$ = this._topBarConf.getFilterOnRefreshForPowerQuality.subscribe(value => {
      if(this.isPowerQualityScreen()){
        this.ctb.filters.forEach(element => {
          if(element?.id){
            element?.payload.forEach(element => {
              this.createFilterForPowerQuality(element);
            });
          }else{
            this.createFilterForPowerQuality(element?.payload[0])
          }
        });
        this.ctb.onFilterChange(false, true);
      }
    });
  }

  getAlertTypeBasedOnConfiguration(mainScreen){
    this.notificationAlertsList = [];
    let selectedLang = this._storageService.getStorageItem('lang')
    if (!['wifi','notifications', 'power_quality_sustained', 'power_quality_momentary', 'power_quality_voltage', preferencesConstant.WORK_ORDER].includes(this.mainScreen)) {
      this.notificationAlertListSub$ = this.ctb.getAllAlertTypeList().subscribe((response) => {
        const responseData = response['code'] == '200' && response?.data ? response?.data[mainScreen] : [];
        responseData?.sort((a, b) => a?.name['en'].toLowerCase() > b?.name['en'].toLowerCase() ? 1 : -1);
        responseData?.forEach(element => {
          const  notificationAlert= {
            name: element?.name[selectedLang],
            value: element?.threshold_type.split('___')[0],
            selectable: true
          };
          this.notificationAlertsList.push(notificationAlert);
        });
        let notificationsAlertAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'threshold_type');
        this.notificationAlertsList = this.notificationAlertsList.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (notificationsAlertAttribute) {
          this.ctb.attributesData.values['threshold_type'] = this.notificationAlertsList;
        }
      });
    }
  }

  getExceptionTypeBasedOnConfiguration(mainScreen){
    this.notificationExceptionsList = [];
    if (['light', 'transformers'].includes(this.mainScreen)) {
      const params = {
        "type": this.mainScreen
      };
      if (this.notificationExceptionsListSub$)
        this.notificationExceptionsListSub$.unsubscribe();
      this.notificationExceptionsListSub$ = this.ctb.getAllExceptionTypeList(params).subscribe((response) => {
        this.notificationExceptionsList = [];
        const responseData = response['code'] == '200' && response?.data ? response?.data : [];
        responseData?.sort((a, b) => a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1);
        responseData?.forEach(element => {
          const  exceptionEvent = {
            name: element.name,
            value: element.key,
            selectable: true
          };
          this.notificationExceptionsList.push(exceptionEvent);
        });
        this.notificationExceptionsList = this.notificationExceptionsList.sort((a, b) => (a.name > b.name ? 1 : -1));
        let notificationsExceptionAttribute = this.ctb.attributesData?.attributes.find((element) => element.value == 'event');
        if (notificationsExceptionAttribute) {
          this.ctb.attributesData.values['event'] = this.notificationExceptionsList;
        }
      });
    }
  }

  viewNodeFilter() {
    this.viewNodeFilterSub$ = this._topBarConf?.viewNodeFilter?.subscribe(value => {
      if (!isEmpty(value)) {
        this.ctb.filters = [];
        this.preferenceCall = false;
        this.ctb.onSearchApply(value, "search");
      }
    });
  }

  isPowerQualityScreen(): boolean {
    return this.validPowerQualityScreens.includes(this.mainScreen);
  }

  changeCurrentViewMode() {
    this.currentModeSelectionSub = this._topBarConf.currSelectedMode.subscribe(data => {
      this.isPowerQualityTemporalViewEnable = data?.action === 'temporal' ? true : false;
        this.ctb.dateRange.forEach(item => {
          if (item.key === 'last_24_hr' || item.key === 'current_day' || item.key === 'yesterday' || item.key === 'now') {
            item.is_disabled = this.isPowerQualityTemporalViewEnable;
          }
        });
      });
  }

  private restoreCustomDateRangeFromFilter(
    startDate: string | undefined,
    endDate: string | undefined,
    customerTimezone: string
  ): void {
    const localZone = DateTimeCore.guessZone();

    if (startDate) {
      const zonedStartDate = DateTimeCore.toZone(
        DateTimeCore.parseInstant(startDate, localZone),
        customerTimezone
      );
      this.ctb.startDate = new NgbDate(zonedStartDate.year, zonedStartDate.month, zonedStartDate.day);
      this.ctb.startTime = DateTimeCore.format(
        DateTimeCore.parseInstant(startDate, localZone),
        DateTimeFormats.TIME_24
      );
    }

    if (endDate) {
      const zonedEndDate = DateTimeCore.toZone(
        DateTimeCore.parseInstant(endDate, localZone),
        customerTimezone
      );
      this.ctb.endDate = new NgbDate(zonedEndDate.year, zonedEndDate.month, zonedEndDate.day);
      this.ctb.endTime = DateTimeCore.format(
        DateTimeCore.parseInstant(endDate, localZone),
        DateTimeFormats.TIME_24
      );
    }

    this.ctb.selectedDateRange = null;
    this.ctb.isCalenderVisible = true;
  }
  
}
